import HeaderFlexPane from './HeaderFlexPane';
import HeaderPaneProps from './HeaderPaneProps';
import { observer } from 'mobx-react';
import { isFeatureEnabled } from 'owa-feature-flags';
import strings from 'owa-strings/owa-common-strings';
import * as React from 'react';
import { sendMiniMavenDataPoint, destroyWidgetOnPaneDismiss } from 'owa-help-charm';
import MiniMavenPane from './MiniMavenPane';
const isMiniMavenWidgetEnabled: boolean = isFeatureEnabled('help-miniMavenWidget');

@observer
export default class HelpPane extends React.Component<HeaderPaneProps, {}> {
    componentWillUnmount() {
        if (isMiniMavenWidgetEnabled) {
            destroyWidgetOnPaneDismiss();
        }
    }

    render() {
        if (isMiniMavenWidgetEnabled) {
            sendMiniMavenDataPoint({
                sessionId: '',
                eventId: 'HelpPaneRendered',
                eventData: 'Owa Mail',
                loadTime: '',
                isDeeplinkScenario: '',
            });
        }

        return (
            <HeaderFlexPane
                title={() => strings.helpCharm_ariaLabel}
                content={<MiniMavenPane onDismiss={this.props.onDismiss} />}
                onDismiss={this.props.onDismiss}
            />
        );
    }
}
